module.exports = __webpack_public_path__ + "img/phone-three.4e9b564b.png";